module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-videos u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }), _vm._v(" "), (_vm.numberOfCoverVideos > 0) ? _c('div', {
    staticClass: "u-relative u-fit-w u-marg-b-xxl"
  }, [_c('section', {
    staticClass: "u-fit-w u-flex--x u-block@md u-flex--center u-align-center"
  }, _vm._l((this.contentGlobal.videoGames), function(game, index) {
    return (game.video !== null) ? _c('app-btn-filter', {
      key: game.id,
      staticClass: "u-marg-x-xxs u-uppercase u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-x-auto@md u-marg-b-xs@md",
      class: {
        'is-selected': _vm.currentCoverData && game.id === _vm.currentCoverData.videoGameID
      },
      attrs: {
        "to": _vm.$root.getPageURLFromID('videosFilter').replace(':filter', game.slug)
      }
    }, [_c('h2', {
      staticClass: "u-inline-block u-fit"
    }, [_c('img', {
      staticClass: "is-img",
      attrs: {
        "src": game.logo_light,
        "alt": game.name,
        "title": game.name
      }
    })])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.numberOfCoverVideos > 0) ? _c('div', {
    staticClass: "u-marg-b-xxxl"
  }, [(_vm.currentCoverData) ? _c('h2', {
    staticClass: "t-h4 u-uppercase u-block u-valign-top u-marg-b-xl u-align-center u-marg-x-auto u-w2of3 u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.currentCoverData.title)
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.currentCoverData) ? _c('div', {
    staticClass: "o-content t-text--sm u-marg-t-xs u-line-height--lg u-color--gray-blue u-marg-x-auto u-w2of3 u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.currentCoverData.description)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.numberOfCoverVideos > 0) ? _c('h2', {
    staticClass: "t-h4 u-uppercase u-block u-valign-top u-marg-b-xl u-align-center u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.moreTitle)
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "u-fit-w u-flex--x u-block@md u-flex--center u-align-center u-marg-b-xxxl"
  }, [_c('app-btn-filter', {
    staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md u-marg-b-xs@md",
    class: [_vm.currentFilterId === 3 ? 'is-selected' : ''],
    on: {
      "click": function($event) {
        _vm.filter(3)
      }
    }
  }, [_c('h2', {
    staticClass: "u-inline-block u-fit"
  }, [_vm._v("\n                    " + _vm._s(_vm.getTypeById(3).name) + "\n                ")])]), _vm._v(" "), _c('app-btn-filter', {
    staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md u-marg-b-xs@md",
    class: [_vm.currentFilterId === 4 ? 'is-selected' : ''],
    on: {
      "click": function($event) {
        _vm.filter(4)
      }
    }
  }, [_c('h2', {
    staticClass: "u-inline-block u-fit"
  }, [_vm._v("\n                    " + _vm._s(_vm.getTypeById(4).name) + "\n                ")])]), _vm._v(" "), _c('app-btn-filter', {
    staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md",
    class: [_vm.currentFilterId === 5 ? 'is-selected' : ''],
    on: {
      "click": function($event) {
        _vm.filter(5)
      }
    }
  }, [_c('h2', {
    staticClass: "u-inline-block u-fit"
  }, [_vm._v("\n                    " + _vm._s(_vm.getTypeById(5).name) + "\n                ")])])], 1), _vm._v(" "), _c('nav', {
    staticClass: "u-align-center"
  }, _vm._l((_vm.videos), function(column, index) {
    return (_vm.videos.length > 0) ? _c('div', {
      staticClass: "c-hub-column u-inline-block u-valign-top",
      style: ({
        width: Math.floor(100 / _vm.videos.length) + '%'
      })
    }, [(index === 1 && _vm.videos.length === 3) ? _c('div', {
      staticClass: "u-marg-t-lg"
    }) : _vm._e(), _vm._v(" "), _vm._l((column), function(video, i) {
      return (i < _vm.columnLength) ? _c('app-fadein', {
        key: video.key,
        attrs: {
          "delay": index * 70,
          "move": index === 1 && _vm.videos.length === 3 ? 0 : -50
        }
      }, [_c('app-resume', {
        staticClass: "u-marg-x-xs u-marg-b-xxl",
        attrs: {
          "type": _vm.currentFilterId,
          "category": _vm.getTypeById(_vm.currentFilterId).name,
          "date": video.date ? video.date : 0,
          "link": _vm.getVideoUrlBySlug(video.slug),
          "cover": video.cover,
          "title": video.title,
          "text": video.resume,
          "footer": '',
          "share": _vm.contentPage.share
        }
      })], 1) : _vm._e()
    })], 2) : _vm._e()
  })), _vm._v(" "), (_vm.isMoreBtnEnable) ? _c('div', {
    staticClass: "u-align-center"
  }, [_c('app-btn', {
    on: {
      "click": function($event) {
        _vm._moreVideos()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.moreVideo)
    }
  })])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-box--16by9 u-fit-w u-marg-b-lg"
  }, [_c('div', {
    staticClass: "u-fit u-absolute u-pos-tl"
  }, [_c('div', {
    staticClass: "js-jwplayer"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfc85cda"}!./src/scripts/components/page-videos/template.html
// module id = 944
// module chunks = 0